import React from 'react';
import { Label, SparkIcon, TooltipTrigger } from '@spark';

/**
 * Shared form-field label: Spark Label (+ optional required asterisk) and a
 * circle-help icon with a portaled TooltipTrigger so the tip stays above modals.
 */
export default function FieldLabelWithHelp({
    label,
    helpText,
    required = false,
    style,
    className = '',
}) {
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                marginBottom: 4,
                ...style,
            }}
        >
            <Label label={label} showAsterisk={required} className="fs-unmask" />
            {helpText ? (
                <TooltipTrigger text={helpText}>
                    <span
                        className="fs-unmask"
                        style={{
                            display: 'inline-flex',
                            color: 'var(--semantic-action-primary-on-surface-default)',
                            cursor: 'help',
                        }}
                    >
                        <SparkIcon slug="circle-help" size="small" />
                    </span>
                </TooltipTrigger>
            ) : null}
        </div>
    );
}
